import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../../actions/layoutActions";
import { EditUnitOfMeasure } from "./EditUnitOfMeasure";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { useUpdateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { convertServerErrorToFormikErrors } from "../../../../../../utils/formValidationUtils";
import propTypes from "../../../../../../constants/propTypes";
import { unitOfMeasureDataComponentId } from "../UnitOfMeasureContainer";

const EditUnitOfMeasureContainer = ({
  unitOfMeasure,
  dataComponent,
  performUpdateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
}) => {
  useUpdateProcessRequests(dataComponent, {
    onSuccess: () => {
      showSnackNotificationAction("Unit of Measure saved successfully.");
      setReload(unitOfMeasureDataComponentId, true);
      closeModalDialog();
    },
    onError: error => {
      const convertedError = convertServerErrorToFormikErrors(error);
      showSnackNotificationAction(convertedError.name);
    },
  });

  const handleEditUnitOfMeasure = values => {
    performUpdateRequest(
      unitOfMeasureDataComponentId,
      unitOfMeasure.id,
      values
    );
  };

  return (
    <EditUnitOfMeasure
      unitOfMeasure={unitOfMeasure}
      handleEditUnitOfMeasure={handleEditUnitOfMeasure}
      closeModalDialog={closeModalDialog}
    />
  );
};

EditUnitOfMeasureContainer.propTypes = {
  unitOfMeasure: propTypes.unitOfMeasure.isRequired,
  dataComponent: propTypes.dataComponent,
  performUpdateRequest: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dataComponent: getDataComponent(unitOfMeasureDataComponentId, state),
  };
};

const mapDispatchToProps = {
  performUpdateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditUnitOfMeasureContainer);
